import GltfTypes from "../../types/GltfTypes";
import UnlitMaterial from "./UnlitMaterial";
const EXT_ID = 'KHR_materials_unlit';
class Instance {
    constructor(gltfLoader) {
        this.name = EXT_ID;
        this.priority = 1;
        this.loader = gltfLoader;
    }
    acceptElement(data, element) {
        return null;
    }
    loadElement(data) {
        if (data.gltftype === GltfTypes.MATERIAL && data.extensions && data.extensions[EXT_ID]) {
            const unlitMaterial = new UnlitMaterial();
            return unlitMaterial.parse(this.loader, data)
                .then(() => unlitMaterial);
        }
        return null;
    }
}
export default class KHR_texture_transform {
    constructor() {
        this.name = EXT_ID;
    }
    createInstance(gltfLoader) {
        return new Instance(gltfLoader);
    }
}
